import type { AsyncDataOptions } from 'nuxt/app'
import type { KeysOf } from 'nuxt/dist/app/composables/asyncData'

export function useCachedAsyncData<
  ResT,
  DataT,
  PickKeys extends KeysOf<DataT>,
  DefaultT,
>(
  key: string,
  handler: () => Promise<ResT>,
  options?: AsyncDataOptions<ResT, DataT, PickKeys, DefaultT>,
) {
  const nuxtApp = useNuxtApp()

  return useAsyncData(key, handler, {
    getCachedData(key) {
      return nuxtApp?.payload?.data?.[key] || nuxtApp?.static?.data?.[key]
    },
    ...options,
  })
}
